// Shared display helpers for product/seller data from the FastAPI contract
// (docs/api-contract.md). Money arrives as integer USD cents; images as
// relative media paths (resolve with mediaUrl from src/api).

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// Format integer cents as "$12.34". Returns fallback for null/undefined.
export function formatCents(cents, fallback = '—') {
  if (cents === null || cents === undefined) return fallback;
  return usd.format(cents / 100);
}

export function getConditionColor(condition) {
  switch (condition) {
    case 'new': return 'green';
    case 'like_new': return 'pink';
    case 'used_excellent': return 'teal';
    case 'used_good': return 'yellow';
    case 'used_fair': return 'orange';
    case 'refurbished': return 'grape';
    default: return 'gray';
  }
}

export function formatCondition(condition) {
  if (!condition) return '';
  return condition
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// Pick the primary image path from a Product.images array (contract §3.4):
// the is_primary entry, else the first. Returns a relative image_path or null.
export function primaryImagePath(images) {
  if (!images || images.length === 0) return null;
  const primary = images.find((img) => img.is_primary) || images[0];
  return primary.image_path ?? null;
}
